import uniq from 'lodash/uniq';
import { funnelDetailModel } from './funnelDetailModel';

export class FunnelMapModel {
  private _funnelMap: FunnelMap;

  constructor(funnelMap: FunnelMap) {
    this._funnelMap = funnelMap;
  }

  public getFunnelMapLeadingFieldIds = (): string[] => {
    const funnelsData = Object.values(this._funnelMap.funnelsData);
    return uniq(
      funnelsData
        .map((funnel) => funnel.funnelDetails?.leadingObject._leadingFieldId ?? '')
        .filter((id) => !!id),
    );
  };

  public funnelDetailsModelById = (funnelId: string) => {
    return funnelDetailModel(this._funnelMap.funnelsData[funnelId]?.funnelDetails);
  };
}
